import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  ...props
}: ButtonProps) {
  const baseStyles = 'font-display font-bold transition-all duration-200 border-2 border-brand-navy inline-flex items-center justify-center gap-2';
  const variants = {
    primary: 'bg-brand-pink text-brand-navy shadow-quirky hover:shadow-quirky-hover hover:translate-x-[3px] hover:translate-y-[3px]',
    secondary: 'bg-brand-lime text-brand-navy shadow-quirky hover:shadow-quirky-hover hover:translate-x-[3px] hover:translate-y-[3px]',
    outline: 'bg-transparent text-brand-navy hover:bg-brand-yellow shadow-quirky hover:shadow-quirky-hover hover:translate-x-[3px] hover:translate-y-[3px]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-xl'
  };
  return <motion.button whileTap={{
    scale: 0.95
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-148">
      {children}
    </motion.button>;
}